module.exports = __webpack_public_path__ + "static/media/MDO_count.bef7d825.svg";